var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.193,
    height: 24.238,
    viewBox: "0 0 46.193 24.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-left",
    d: "M1.691,21.846l7.449,7.526a1.925,1.925,0,0,0,2.733,0h0a1.925,1.925,0,0,0,0-2.733L5.022,19.748H44.271A1.925,1.925,0,0,0,46.2,17.823h0A1.925,1.925,0,0,0,44.271,15.9H4.906L11.874,8.93a1.925,1.925,0,0,0,0-2.656h0a1.925,1.925,0,0,0-2.733,0L1.691,13.685a5.775,5.775,0,0,0,0,8.162Z",
    transform: "translate(-0.003 -5.704)",
    fill: "#9ADD3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowback);
export default __webpack_public_path__ + "static/media/arrowback.b48d25ee0995941a9ab1c00aa6a2b42e.svg";
export { ForwardRef as ReactComponent };